
<script>
import { onMount } from 'svelte';

import MapManager from '../modules/MapManager.js';

import Filters from './Filters.svelte';
import ListItem from './ListItem.svelte';

export let config;
export let mapdata; 
export let filters;
export let pins;

let foundString = '';
$: foundString;
let scale = config.scale;
let maxCheckbox = config.maxCheckbox;

let listing = [];
$: listing;
let manager = {};

let pincount = mapdata.length;

onMount(async () => {

  let defaults = {
    mapid : config.mapid,
    lat: config.center.lat,
    lng: config.center.lng,
    mapdata: mapdata,
    zoom: config.zoom,
    filedir : config.filedir,
    pins : pins
  }

  manager = new MapManager(defaults, updateListing);  
});

function searchForPlace(event) {
  manager.setCategory(event.detail.filter);
  manager.setVisibility();
  if(event.detail.location != ''){
    manager.getByLatLng(event.detail.location);
  } else {
    manager.filter();
  }
}

function updateListing(newlistOrder){
  listing = newlistOrder;
  updateFoundText();
}

listing = mapdata.map((elm,index) => {
  return { title: elm.title, address: elm.address, uri : elm.uri, index:index };
});

function updateFoundText(){
  foundString = window.mapinfo.translate.some;

  if(listing.length == pincount) {
      foundString = window.mapinfo.translate.all;
  } 
  foundString = foundString.replace('%d', listing.length);
}

function openMapPin(event) {
  manager.openMapPin(event.detail.index);
}



</script>
<style>
.map-area {height: 300px; width:100%}

@media screen and (min-width:760px){
  .map-holder {
    display:grid;
    grid-template-columns: 40% 60%;
    grid-template-rows: auto 1fr;
    height:80vh;
    max-height: 800px;
  }
  .map-area {
    order:2;
    grid-row:1/ span 2;
    height: 100%;
    height:80vh;
    max-height: 800px;
  }
  .filters {
    order:1;
    grid-row:1;
    padding-bottom: 2em;    
  }
  .listings{
    order:3;    
    overflow: auto;
    grid-row:2;
    vertical-align: top;
  }
}
.listings {
  counter-reset: items;
  padding-left:1em;
  padding-right:1em;
}

p.message {
  text-align: center;
}
</style>
<div class='map-holder'>
  <div id="{config.mapid}" class='map-area'></div>
  <div class='filters'>
      <Filters {filters} on:search={searchForPlace} {maxCheckbox} />
      <p class='message'>{foundString}</p>
  </div>
  <div class="listings">
      {#each listing as item}
        <ListItem {item} {scale} on:goto={openMapPin}/>
      {/each}
  </div>
</div>